import type { GetArrayReturnType } from '@ab-core/functions/formValidation';
import { HorizontalLine } from '@ab-core/horizontalline';
import { Switch } from '@ab-core/switch';
import { getTestIdProp } from '@ab-core/testing';
import Text, { FontTypes } from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';

type SettingsType = {
    selectOnChange: (key: string, value: boolean) => void;
    fields: GetArrayReturnType;
    name: string;
};

export const Settings: FC<SettingsType> = ({ fields, selectOnChange, name }) => {
    return (
        <div>
            <Text type={FontTypes.Overline} className="my-small4" color="gray70">
                {name}
            </Text>
            {fields.map((i) => (
                <div key={i.key} className="mb-small4">
                    <Switch
                        {...i}
                        onChange={(e) => selectOnChange(i.key, e.target.checked)}
                        {...getTestIdProp(`product-card-configurator-${i.key}-switch`)}
                    />
                </div>
            ))}
            <HorizontalLine />
        </div>
    );
};

export const SettingsMeta: FC = () => {
    return (
        <>
            <Text className="my-small4" type={FontTypes.Caption} color="gray70">
                Die Vorschau zeigt eine mögliche Darstellung anhand von Dummy Daten an. Listenansicht ähnlich.
            </Text>
            <Text type={FontTypes.Caption} color="gray70">
                Einstellungen werden nur in Ihrem aktuellen Browser gespeichert. Auf einem anderen Gerät / Browser
                müssen Sie die Einstellung erneut vornehmen.
            </Text>
        </>
    );
};
